<div class="title">{{ title }}</div>
<div class="subtitle" *ngIf="this.subtitle">{{ this.subtitle }}</div>

<div class="d-flex bottom-space">
  <mat-checkbox
    class="right-space"
    [disabled]="isDisabled"
    (change)="answered({ values: checked, index: 0 })"
    [(ngModel)]="checked[0]"
  >
    {{ leftText }}
  </mat-checkbox>
  <mat-checkbox
    [disabled]="isDisabled"
    (change)="answered({ values: checked, index: 1 })"
    [(ngModel)]="checked[1]"
  >
    {{ rightText }}
  </mat-checkbox>
</div>
